import React from "react";
import Paragraph from "../../components/atoms/Paragraph/Paragraph";
import AppButton from "../../components/atoms/AppButton/AppButton";
import PageScreen from "../../components/organisms/Page/PageScreen";
import {ReactComponent as KotomatikLogo} from '../../icons/svg/kontomatik.svg'
import {APP_COLOR, APP_FONT_SIZE} from "../../components/atoms/AtomsGlobalProps";
import {UI_BUTTON_TYPE} from "../../components/atoms/AppButton/AppButtonProps";
import './KontomatikSignInRedirectionPanelStyles.scss'
import LoanOfferSummaryPanel from "../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel";

export enum KONTOMATIK_REDIRECTION_PANEL_MODE {
    DEFAULT = "DEFAULT",
    START_ERROR = "START_ERROR",
    RETURN_ERROR = "RETURN_ERROR",
}

interface KontomatikSignInRedirectionPanelProps {
    isRedirectStarting: boolean;
    mode: KONTOMATIK_REDIRECTION_PANEL_MODE;
    onStartRedirection: () => void;
}

const KontomatikSignInRedirectionPanel = (props: KontomatikSignInRedirectionPanelProps) => {
    const {isRedirectStarting, mode, onStartRedirection} = props;
    // todo
    // const textContent = useTextContents()

    const isRetryMode = mode === KONTOMATIK_REDIRECTION_PANEL_MODE.RETURN_ERROR;
    // const title = isRetryMode ? textContent('bmVerifyPage.redirection.retryMode.header')
    //     : textContent('bmVerifyPage.redirection.firstRedirection.header');
    const title = isRetryMode
        ? "Ponów potwierdzenie dochodu" : "Potwierdź dochody";

    // const description = isRetryMode
    //     ? textContent('bmVerifyPage.redirection.retryMode.text')
    //     : textContent('bmVerifyPage.redirection.firstRedirection.text');

    const description = isRetryMode
        ? "Proces potwierdzania dochodów został przerwany przed przekazaniem nam niezbędnych informacji. Spróbuj jeszcze raz wybrać swój bank i przejść ponownie proces."
        : "Klikając przycisk poniżej, przejdziesz do bezpiecznego panelu Kontomatik, gdzie wskażesz swój bank i potwierdzisz uzyskiwany dochód w serwisie internetowym banku.";

    return (
        <PageScreen
            title={{title: title, line: true}}
            panel={<LoanOfferSummaryPanel loanVariant='predefined' />}
        >
            <div className='kontomatik-redirection-wrapper'>
                <Paragraph align={"justify"}>
                    {description}
                </Paragraph>
                <Paragraph align='center'>
                    {/*{
                    textContent('bmVerifyPage.redirection.loginIsSave')
                    }*/}
                    Twoje dane logowania sa szyfrowane i niewidoczne dla nas.
                </Paragraph>

                {/*{(mode === KONTOMATIK_REDIRECTION_PANEL_MODE.START_ERROR || mode === KONTOMATIK_REDIRECTION_PANEL_MODE.RETURN_ERROR) && (*/}
                {/*    <Paragraph color={APP_COLOR.ERROR} align={"center"} bold size={APP_FONT_SIZE.SMALL}>*/}
                {/*        /!*{*/}
                {/*        textContent('bmVerifyPage.redirection.error')*/}
                {/*        }*!/*/}
                {/*        Nie udalo sie ukonczyc procesu przekierowania. Sprobuj ponownie.*/}
                {/*    </Paragraph>*/}
                {/*)}*/}

                <AppButton
                    isLoading={isRedirectStarting}
                    disabled={isRedirectStarting}
                    uiButtonType={UI_BUTTON_TYPE.PRIMARY}
                    onClick={onStartRedirection}
                >
                    {/*
                {isRedirectStarting?
                textContent('bmVerifyPage.redirection.isRedirectStarting')
                : textContent('bmVerifyPage.redirection.start')
                }
                */}
                    {isRedirectStarting ? "Przekierowujemy..." : "Rozpocznij"}
                </AppButton>

                <div className={"center"}>
                    <KotomatikLogo/>
                </div>


                <Paragraph align='center' color={APP_COLOR.GRAY} size={APP_FONT_SIZE.EXTRA_SMALL}>
                    {/*textContent('bmVerifyPage.redirection.loginIsSave')*/}
                    Po zakonczeniu weryfikacji wrocisz automatycznie do serwisu OPENA.
                </Paragraph>
            </div>
        </PageScreen>
    );
};

export default KontomatikSignInRedirectionPanel;
